(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_9da686a"] && !Shopify.designMode) return;
  try {
    (function(){
    function alignFooter(){
      var ft = document.querySelector('.lt-ft');
      if (!ft) return;
      ft.style.width = '';
      ft.style.marginLeft = '';
      ft.style.marginRight = '';
      var rect = ft.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      ft.style.marginLeft = (-rect.left) + 'px';
      ft.style.marginRight = (rect.left + rect.width - vw) + 'px';
      ft.style.width = vw + 'px';
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', alignFooter);
    } else {
      alignFooter();
    }
    window.addEventListener('load', alignFooter);

    // Only re-align on REAL viewport-width changes — never on scroll-induced
    // height changes (mobile URL bar). Listening to 'resize' caused reflow
    // cascades that crashed mobile Safari on pages with lots of DOM.
    var lastVw = document.documentElement.clientWidth;
    var rafId = null;
    window.addEventListener('resize', function(){
      var vw = document.documentElement.clientWidth;
      if (vw === lastVw) return;        // width unchanged (URL-bar scroll) → skip
      lastVw = vw;
      if (rafId) return;
      rafId = window.requestAnimationFrame(function(){
        rafId = null;
        alignFooter();
      });
    }, { passive: true });
    window.addEventListener('orientationchange', alignFooter);
  })();
  } catch(e) { console.error(e); }
})();

})();
